import { Factory, association } from 'miragejs';
import { faker } from '@faker-js/faker';

const PROVIDERS = ['google', 'microsoft_service'];

export default Factory.extend({
  company: association(),

  email() {
    return faker.internet.email();
  },

  provider() {
    return faker.helpers.arrayElement(PROVIDERS);
  },
});
